import React from 'react'
import { useParams } from '@tanstack/react-router'
import { AlertTriangleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	getSalesEntitiesTree,
	useSalesEntitiesQuery,
} from '@/entities/optimization-group'
import { usePromoCampaignsQuery } from '@/entities/promo-campaign'

import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
} from '@/shared/components/ui/empty'
import { Spinner } from '@/shared/components/ui/spinner'

import PromoCampaignForm from './PromoCampaignForm'

export default function PromoCampaignPage() {
	const { t } = useTranslation()

	const { id } = useParams({ strict: false })
	const isNew = !id
	const promoCampaigns = usePromoCampaignsQuery()
	const salesEntitiesQuery = useSalesEntitiesQuery()
	const promoCampaign = promoCampaigns?.data?.find(
		(campaign) => campaign.id === id
	)
	const propsTo = {
		isLoadingList: promoCampaigns.isLoading,
		promoCampaign,
		isNew,
		canEdit: promoCampaign ? promoCampaign.source != 'integration' : true,
		options: {
			pos_ids: getSalesEntitiesTree(salesEntitiesQuery.data) || [],
		},
	}
	if (promoCampaigns.isLoading && !promoCampaign) {
		return (
			<Empty className='flex h-full flex-col items-center justify-center'>
				<EmptyHeader>
					<EmptyMedia variant='icon'>
						<Spinner className='text-muted-foreground' />
					</EmptyMedia>
					<EmptyDescription>{t('loading')}</EmptyDescription>
				</EmptyHeader>
			</Empty>
		)
	} else if (!promoCampaign && !isNew) {
		return (
			<Empty className='flex h-full flex-col items-center justify-center'>
				<EmptyHeader>
					<EmptyMedia variant='icon'>
						<AlertTriangleIcon className='text-muted-foreground' />
					</EmptyMedia>
					<EmptyDescription>
						{t('pricing_campaigns_not_found', {
							defaultValue: 'Pricing campaign not found',
						})}
					</EmptyDescription>
				</EmptyHeader>
			</Empty>
		)
	}

	return <PromoCampaignForm {...propsTo} />
}
